import { Pays } from '../../intervenant/models/pays.model';
import { DataIdConverterFactory } from 'src/app/core/services/mapper/data-id.converter';
import { Organisme } from '../../intervenant/models/organisme.model';

export class Salle {
    static jsonMap = {
        id: 'id',
        nom: 'nom',
        adresse: 'adresse',
        codePostal: 'codePostal',
        ville: 'ville',
        pays: { key: 'idPays', converter: new (DataIdConverterFactory.build(Pays, 'pays'))() },
        cedex: 'cedex',
        organisme: { key: 'idOrganisme', converter: new (DataIdConverterFactory.build(Organisme, 'organismes'))() }
    };

    id: number;
    nom: string;
    adresse: string;
    codePostal: string;
    ville: string;
    pays: Pays;
    cedex: string;
    organisme: Organisme;
}
